import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ComplianceMissedGuidelinesComponent } from './compliance-missed-guidelines/compliance-missed-guidelines.component';

@NgModule({
  declarations: [ComplianceMissedGuidelinesComponent],
  imports: [TranslocoModule],
  exports: [ComplianceMissedGuidelinesComponent],
})
export class ResultsModule {}
